import { render } from "./DriversListing.vue?vue&type=template&id=5b0285ce&ts=true"
import script from "./DriversListing.vue?vue&type=script&lang=ts"
export * from "./DriversListing.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__